import React from "react";
import styled from "styled-components";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { useTranslation } from "react-i18next";
import { PLATFORM_URL } from "../config";

const currentYear = new Date().getFullYear();

const Footer = () => {
  const { t } = useTranslation();
  return (
    <BgBlue>
      <FooterContainer>
        {/* <StyledHR /> */}

        <CopyrightText>
          {t("footer.rights", { year: currentYear })}{" "}
          <StyledLink href={`${PLATFORM_URL}/privacy.html`} target="_legal">
            {t("footer.privacy")}
          </StyledLink>{" "}
          {t("footer.and")}{" "}
          <StyledLink href={`${PLATFORM_URL}/terms.html`} target="_legal">
            {t("footer.terms")}
          </StyledLink>{" "}
          {t("footer.apply")}
          <br />
          {t("footer.recaptcha")}{" "}
          <StyledLink href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
            {t("footer.googlePrivacy")}
          </StyledLink>{" "}
          {t("footer.and")}{" "}
          <StyledLink href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">
            {t("footer.termsOfService")}
          </StyledLink>
          .
        </CopyrightText>
      </FooterContainer>
    </BgBlue>
  );
};

export default Footer;

const BgBlue = styled.div`
  background: #2E7D32;
  /* padding: 30px 15px; */
  color: #ffffff;
`;

const FooterContainer = styled.div`
  max-width: 1140px;
  margin: 0 auto;
  text-align: center;
`;

const StyledLink = styled.a`
  background-color: transparent;
  border: none;
  font-size: 14px;
  color: #ffffff;
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;

const CopyrightText = styled.p`
  font-size: 14px;
  color: #ffffff;

  a {
    color: #ffffff;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
`;